import React from "react"
import "./common.scss"

const BarLoader = () => <div className="loader">Loading...</div>

export { BarLoader }
